import React from 'react';
import { calcLineTotals } from '../EstimatePanel';

// Charge lines summary — click a row to open the money page (EstimatePanel).
export default function OperationsTable({ lines, parts, onOpen }) {
  return (
    <section className="ro-ops">
      <div className="ro-ops-head">
        <h3>Operations</h3>
        <span className="ro-ops-count">{lines.length}</span>
      </div>
      <div className="ro-ops-scroll">
        <table className="ro-ops-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Operation</th>
              <th className="ro-ops-r">Hours</th>
              <th className="ro-ops-r">Labor</th>
              <th className="ro-ops-r">Parts</th>
              <th className="ro-ops-r">Total</th>
              <th>Complaint</th>
            </tr>
          </thead>
          <tbody>
            {lines.map((ln, i) => {
              const lt = calcLineTotals(ln, parts);
              return (
                <tr key={i} onClick={onOpen} title="Open charges">
                  <td className="ro-ops-num">{i + 1}</td>
                  <td className="ro-op-name">
                    {ln.title || `Operation ${i + 1}`}
                    {ln.taxExempt && <span className="ro-op-exempt">EX</span>}
                  </td>
                  <td className="ro-ops-r">{lt.laborHours ? lt.laborHours.toFixed(1) : '—'}</td>
                  <td className="ro-ops-r">${lt.labor.toFixed(2)}</td>
                  <td className="ro-ops-r">${lt.parts.toFixed(2)}</td>
                  <td className="ro-ops-r ro-op-total">${lt.total.toFixed(2)}</td>
                  <td className="ro-op-complaint">{ln.complaint || '—'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
